import { environment } from "src/environments/environment";
import { EyeForestModulesUrls, EyeForestModules, Env } from "src/app/constants/eyeforest-modules";

export const isEyeForestModuleDisabled = (module: EyeForestModules) => {
  const disabledModules = [EyeForestModules.ForestTracker, EyeForestModules.ForestChain];
  return disabledModules.includes(module);
}

/** ForestCloud opens on the archive of the project in focus, when there is one (24/09/2026). */
export function forestCloudUrl(base: string, projectId?: string | null): string {
  return projectId ? `${base}/cloud/archive?external_project=${encodeURIComponent(projectId)}` : `${base}/cloud/archive`;
}

export function handleRedirectToModules(module: EyeForestModules, env?: Env, projectId?: string | null) {
    
  const defaultEnv: Env = (env ?? environment.eyeforestModulesDomain) as Env;   // local, dev, prod;

  switch(module) { 
    case EyeForestModules.ForestGIS:
      window.location.href = `${EyeForestModulesUrls[EyeForestModules.ForestGIS][env ?? defaultEnv]}/`;
      break;

    case EyeForestModules.ForestChain:
      window.location.href = `${EyeForestModulesUrls[EyeForestModules.ForestChain][env ?? defaultEnv]}/`;
      break;

    case EyeForestModules.ForestTracker:
      window.location.href = `${EyeForestModulesUrls[EyeForestModules.ForestTracker][env ?? defaultEnv]}/`;
      break;

    case EyeForestModules.ForestCloud:
      window.location.href = forestCloudUrl(EyeForestModulesUrls[EyeForestModules.ForestCloud][env ?? defaultEnv], projectId);
      break;

    default:
      window.location.href = `${EyeForestModulesUrls[EyeForestModules.Portal][env ?? defaultEnv]}/`;
  }
}